import {
  Home as IconHome,
  ReceiptAlt as IconReceipt,
  UserCircle as IconUserCircle,
  Cog as IconCog,
  QuestionCircle as IconQuestionCircle,
  Bareksa as IconBareksa,
  ChartPieAlt as IconChartPieAlt
} from '@/components/ui/icons'
import { GOLD_TREASURY_CODE } from '@/constant/product'

// Navbar

export const sidebarDrawer = [
  {
    name: 'Settings',
    pathname: `${process.env.REACT_APP_PREFIX}/settings`,
    type: 'link'
  },
  {
    name: 'Bantuan',
    pathname: null,
    type: 'action'
  },
  {
    name: 'Logout',
    pathname: null,
    type: 'action'
  }
]

export const sidebar = [
  {
    index: 0,
    pathname: process.env.REACT_APP_PREFIX,
    title: 'Home',
    type: 'icon',
    Icon: IconHome
  },
  {
    index: 1,
    title: 'Produk',
    type: 'icon',
    Icon: IconBareksa,
    children: [
      {
        pathname: `${process.env.REACT_APP_PREFIX}/product/mutualfund`,
        title: 'Reksa Dana',
        type: 'image',
        Icon: '/images/icons/Icon_Reksadana.webp'
      },
      {
        pathname: `${process.env.REACT_APP_PREFIX}/product/gold`,
        title: 'Emas',
        type: 'image',
        Icon: '/images/icons/Icon_Emas.webp'
      }
    ]
  },
  {
    index: 2,
    pathname: `${process.env.REACT_APP_PREFIX}/portfolio`,
    title: 'Portofolio',
    type: 'icon',
    Icon: IconChartPieAlt
  },
  {
    index: 3,
    pathname: `${process.env.REACT_APP_PREFIX}/transaction`,
    title: 'Transaksi',
    type: 'icon',
    Icon: IconReceipt
  },
  {
    index: 4,
    pathname: `${process.env.REACT_APP_PREFIX}/account`,
    title: 'Akun',
    type: 'icon',
    Icon: IconUserCircle
  }
]

export const navbar = [
  {
    id: 'cs',
    pathname: process.env.REACT_APP_PREFIX,
    Icon: IconQuestionCircle
  },
  {
    id: 'settings',
    pathname: `${process.env.REACT_APP_PREFIX}/settings`,
    Icon: IconCog
  }
]

export const navbarSearchProducts = {
  list: [
    process.env.REACT_APP_PREFIX,
    `${process.env.REACT_APP_PREFIX}/`,
    `${process.env.REACT_APP_PREFIX}/product`,
    `${process.env.REACT_APP_PREFIX}/portfolio`
  ],
  contains: `${process.env.REACT_APP_PREFIX}/product`
}

export const publicPages = {
  login: {
    component: 'LoginPage',
    name: 'login',
    path: '/'
  },
  resetPassword: {
    component: 'ResetPasswordPage',
    name: 'resetPassword',
    path: '/auth/reset-password'
  },
  forgotPassword: {
    component: 'ForgotPasswordPage',
    name: 'forgotPassword',
    path: '/auth/forgot-password'
  },
  forgotPasswordSuccess: {
    component: 'ForgotPasswordSuccessPage',
    name: 'forgotPasswordSuccess',
    path: '/auth/forgot-password/success'
  },
  setPassword: {
    component: 'SetPasswordPage',
    name: 'setPassword',
    path: '/auth/set-password'
  },
  register: {
    component: 'RegisterPage',
    name: 'register',
    path: '/auth/register'
  },
  registerSuccess: {
    component: 'RegisterSuccessPage',
    name: 'registerSuccess',
    path: '/auth/register/success'
  },
  onboarding: {
    component: 'OnboardingPage',
    name: 'onboarding',
    path: '/auth/onboarding'
  },
  onboardingEmail: {
    component: 'OnboardingEmailPage',
    name: 'onboarding-email',
    path: '/auth/onboarding/email'
  },
  onboardingEmailOtp: {
    component: 'OnboardingEmailOtpPage',
    name: 'onboarding-email-otp',
    path: '/auth/onboarding/email-otp'
  },
  onboardingPhone: {
    component: 'OnboardingPhonePage',
    name: 'onboarding-phone',
    path: '/auth/onboarding/phone'
  },
  onboardingPhoneOtp: {
    component: 'OnboardingPhoneOtpPage',
    name: 'onboarding-phone-otp',
    path: '/auth/onboarding/phone-otp'
  },
  onboardingPassword: {
    component: 'OnboardingPasswordPage',
    name: 'onboarding-password',
    path: '/auth/onboarding/password'
  },
  riskProfile: {
    component: 'RiskProfilePage',
    name: 'risk-profile',
    path: '/auth/onboarding/risk-profile'
  }
}

export const authPages = {
  otpMethods: {
    component: 'OTPMethods',
    name: 'otp-methods',
    path: '/auth/otp-methods'
  },
  verifyOTP: {
    component: 'OTPPassword',
    name: 'otp-password',
    path: '/auth/otp-password'
  }
}

export const privatePages = {
  home: {
    component: 'DashboardPage',
    name: 'home',
    path: process.env.REACT_APP_PREFIX,
    menu: process.env.REACT_APP_PREFIX,
    dashboardType: '1'
    // isShowSearch: false
  },
  // Mutual Fund
  // product: { // deprecated
  //   component: 'ProductPage',
  //   name: 'product',
  //   path: `${process.env.REACT_APP_PREFIX}/product`,
  //   menu: `${process.env.REACT_APP_PREFIX}/product`,
  //   dashboardType: '1'
  // },
  productMutualFund: {
    component: 'MutualFundProductPage',
    name: 'product-mutualfund',
    path: `${process.env.REACT_APP_PREFIX}/product/mutualfund`,
    menu: `${process.env.REACT_APP_PREFIX}/product/mutualfund`,
    dashboardType: '1'
  },
  // productSearch: {
  //   component: 'ProductSearchPage',
  //   name: 'product-search',
  //   path: `${process.env.REACT_APP_PREFIX}/product/search/:keyword`,
  //   menu: `${process.env.REACT_APP_PREFIX}/product`,
  //   dashboardType: '1'
  // },
  productCompareMutualFund: {
    component: 'ProductCompareMutualFundPage',
    name: 'product-compare-mutualfund',
    path: `${process.env.REACT_APP_PREFIX}/product/compare/mutualfund/:codes`,
    menu: `${process.env.REACT_APP_PREFIX}/product`,
    dashboardType: '1'
  },
  productDetail: {
    component: 'MFProductDetailPage',
    name: 'product-detail',
    path: `${process.env.REACT_APP_PREFIX}/product/mutualfund/:product_code`,
    menu: `${process.env.REACT_APP_PREFIX}/product`,
    dashboardType: '1'
  },
  portfolio: {
    component: 'PortfolioPage',
    name: 'portfolio',
    path: `${process.env.REACT_APP_PREFIX}/portfolio`,
    menu: `${process.env.REACT_APP_PREFIX}/portfolio`,
    dashboardType: '1'
  },
  mutualfundSubscription: {
    component: 'MutualFundSubscriptionPage',
    name: 'mutualfund-subscription',
    path: `${process.env.REACT_APP_PREFIX}/product/mutualfund/:product_code/subscription`,
    menu: `${process.env.REACT_APP_PREFIX}/product/mutualfund/:product_code/subscription`,
    dashboardType: '2',
    title: {
      label: 'Beli Reksa Dana',
      withBack: true
    }
  },
  mutualfundRedemption: {
    component: 'MutualFundRedemptionPage',
    name: 'mutualfund-redemption',
    path: `${process.env.REACT_APP_PREFIX}/product/mutualfund/:product_code/redemption`,
    menu: `${process.env.REACT_APP_PREFIX}/product/mutualfund/:product_code/redemption`,
    dashboardType: '2',
    title: {
      label: 'Jual Reksa Dana',
      withBack: true
    }
  },
  mutualfundRedemptionOtp: {
    component: 'MutualFundRedemptionOtpPage',
    name: 'mutualfund-redemption-otp',
    path: `${process.env.REACT_APP_PREFIX}/product/mutualfund/:product_code/redemption/otp`,
    menu: `${process.env.REACT_APP_PREFIX}/product/mutualfund/:product_code/redemption`,
    dashboardType: '2',
    title: {
      label: 'Verifikasi OTP',
      withBack: true
    }
  },
  mutualfundRedemptionSuccess: {
    component: 'MutualFundRedemptionSuccessPage',
    name: 'mutualfund-redemption-success',
    path: `${process.env.REACT_APP_PREFIX}/product/mutualfund/:product_code/redemption/success`,
    menu: `${process.env.REACT_APP_PREFIX}/product/mutualfund/:product_code/redemption`,
    dashboardType: '2',
    title: {
      label: '',
      withBack: false
    }
  },
  // Gold
  productGold: {
    component: 'GoldProductPage',
    name: 'gold-product',
    path: `${process.env.REACT_APP_PREFIX}/product/gold`,
    menu: `${process.env.REACT_APP_PREFIX}/product/gold`,
    dashboardType: '1'
  },
  goldOnboarding: {
    component: 'GoldOnboardingPage',
    name: 'gold-onboarding',
    path: `${process.env.REACT_APP_PREFIX}/gold/onboarding`,
    menu: `${process.env.REACT_APP_PREFIX}/gold/onboarding`,
    dashboardType: '2',
    title: {
      label: 'Registrasi Emas',
      withBack: true
    }
  },
  goldOnboardingForm: {
    component: 'GoldOnboardingFormPage',
    name: 'gold-onboarding-form',
    path: `${process.env.REACT_APP_PREFIX}/gold/onboarding/form`,
    menu: `${process.env.REACT_APP_PREFIX}/gold/onboarding/form`,
    dashboardType: '2',
    title: {
      label: 'Registrasi Emas',
      withBack: true
    }
  },
  goldSubscription: {
    component: 'GoldSubscriptionPage',
    name: 'gold-subscription',
    path: `${process.env.REACT_APP_PREFIX}/product/gold/:product_code/subscription`,
    menu: `${process.env.REACT_APP_PREFIX}/product/gold/:product_code/subscription`,
    dashboardType: '2',
    title: {
      label: 'Beli Emas',
      withBack: true
    }
  },
  goldRedemption: {
    component: 'GoldRedemptionPage',
    name: 'gold-redemption',
    path: `${process.env.REACT_APP_PREFIX}/product/gold/:product_code/redemption`,
    menu: `${process.env.REACT_APP_PREFIX}/product/gold/:product_code/redemption`,
    dashboardType: '2',
    title: {
      label: 'Jual Emas',
      withBack: true
    }
  },
  goldSync: {
    component: 'GoldSyncPage',
    name: 'gold-sync',
    path: `${process.env.REACT_APP_PREFIX}/gold/sync`,
    menu: `${process.env.REACT_APP_PREFIX}/gold/sync`,
    dashboardType: '2',
    title: {
      label: 'Sinkronasi Portofolio',
      withBack: true
    }
  },
  // Payment
  payReviewOrder: {
    component: 'PayReviewOrderPage',
    name: 'pay-review-order',
    path: `${process.env.REACT_APP_PREFIX}/pay/review-order/gold/:order_no`,
    menu: `${process.env.REACT_APP_PREFIX}/pay/review-order/gold/:order_no`,
    dashboardType: '2',
    title: {
      label: 'Review Transaksi',
      withBack: true
    }
  },
  payReviewOrderMutualfund: {
    component: 'PayOrderReviewMutualfundPage',
    name: 'pay-review-order-mutualfund',
    path: `${process.env.REACT_APP_PREFIX}/pay/review-order/mutualfund/:order_no`,
    menu: `${process.env.REACT_APP_PREFIX}/pay/review-order/mutualfund/:order_no`,
    dashboardType: '2',
    title: {
      label: 'Review Transaksi',
      withBack: true
    }
  },
  payTransferBank: {
    component: 'PayTransferBankPage',
    name: 'pay-transfer-bank',
    path: `${process.env.REACT_APP_PREFIX}/pay/transfer-bank/gold/:order_no`,
    menu: `${process.env.REACT_APP_PREFIX}/pay/transfer-bank/gold/:order_no`,
    dashboardType: '2',
    title: {
      label: 'Transfer Bank',
      withBack: true
    }
  },
  payTransferBankMutualfund: {
    component: 'PayTransferBankMutualfundPage',
    name: 'pay-transfer-bank-mutualfund',
    path: `${process.env.REACT_APP_PREFIX}/pay/transfer-bank/mutualfund/:order_no`,
    menu: `${process.env.REACT_APP_PREFIX}/pay/transfer-bank/mutualfund/:order_no`,
    dashboardType: '2',
    title: {
      label: 'Transfer Bank',
      withBack: true
    }
  },
  paySuccess: {
    component: 'PaySuccessPage',
    name: 'pay-transfer-bank',
    path: `${process.env.REACT_APP_PREFIX}/pay/success/:order_no`,
    menu: `${process.env.REACT_APP_PREFIX}/pay/success/:order_no`,
    dashboardType: '2',
    title: {
      label: '',
      withBack: false
    }
  },
  // Sell
  goldRedemptionOtp: {
    component: 'GoldRedemptionOtpPage',
    name: 'gold-redemption-otp',
    path: `${process.env.REACT_APP_PREFIX}/sell/otp/gold`,
    menu: `${process.env.REACT_APP_PREFIX}/sell/otp/gold`,
    dashboardType: '2',
    title: {
      label: 'Verifikasi OTP',
      withBack: true
    }
  },
  goldRedemptionSuccess: {
    component: 'GoldRedemptionSuccessPage',
    name: 'gold-redemption-success',
    path: `${process.env.REACT_APP_PREFIX}/product/gold/:product_code/redemption/success`,
    menu: `${process.env.REACT_APP_PREFIX}/product/gold/:product_code/redemption`,
    dashboardType: '2',
    title: {
      label: '',
      withBack: false
    }
  },
  sellReviewOrderGold: {
    component: 'SellReviewOrderGoldPage',
    name: 'sell-review-order-gold',
    path: `${process.env.REACT_APP_PREFIX}/sell/review-order/gold`,
    menu: `${process.env.REACT_APP_PREFIX}/sell/review-order/gold`,
    dashboardType: '2',
    title: {
      label: 'Konfirmasi Penjualan',
      withBack: true,
      backPath: `${process.env.REACT_APP_PREFIX}/product/gold/${GOLD_TREASURY_CODE}/redemption`
    }
  },
  sellReviewOrderMutualfund: {
    component: 'SellReviewOrderMutualfundPage',
    name: 'sell-review-order-mutualfund',
    path: `${process.env.REACT_APP_PREFIX}/sell/review-order/mutualfund`,
    menu: `${process.env.REACT_APP_PREFIX}/sell/review-order/mutualfund`,
    dashboardType: '2',
    title: {
      label: 'Konfirmasi Penjualan',
      withBack: true
    }
  },

  // Transaction
  transaction: {
    component: 'TransactionPage',
    name: 'transaction',
    path: `${process.env.REACT_APP_PREFIX}/transaction`,
    menu: `${process.env.REACT_APP_PREFIX}/transaction`,
    dashboardType: '1'
  },
  transactionDetailMF: {
    component: 'TransactionDetailMFPage',
    name: 'transaction-detail-mf',
    path: `${process.env.REACT_APP_PREFIX}/transaction/mutualfund/:order_no`,
    menu: `${process.env.REACT_APP_PREFIX}/transaction`,
    dashboardType: '2',
    title: {
      label: 'Detail Transaksi',
      withBack: true
    }
  },
  transactionDetailGold: {
    component: 'TransactionDetailGoldPage',
    name: 'transaction-detail-gold',
    path: `${process.env.REACT_APP_PREFIX}/transaction/gold/:order_no`,
    menu: `${process.env.REACT_APP_PREFIX}/transaction`,
    dashboardType: '2',
    title: {
      label: 'Detail Transaksi',
      withBack: true
    }
  },
  // Account
  account: {
    component: 'AccountPage',
    name: 'account',
    path: `${process.env.REACT_APP_PREFIX}/account`,
    menu: `${process.env.REACT_APP_PREFIX}/account`,
    dashboardType: '1'
  },
  reminderAdd: {
    component: 'ReminderAddPage',
    name: 'reminder/add',
    path: `${process.env.REACT_APP_PREFIX}/reminder/add`,
    menu: process.env.REACT_APP_PREFIX,
    dashboardType: '1'
  },
  reminderEdit: {
    component: 'ReminderEditPage',
    name: 'reminder/edit',
    path: `${process.env.REACT_APP_PREFIX}/reminder/edit/:id`,
    menu: process.env.REACT_APP_PREFIX,
    dashboardType: '1'
  },
  reminderSuccess: {
    component: 'ReminderSuccessPage',
    name: 'reminder-success',
    path: `${process.env.REACT_APP_PREFIX}/reminder/success/:flag`,
    menu: process.env.REACT_APP_PREFIX,
    dashboardType: '1'
  },
  reminder: {
    component: 'ReminderPage',
    name: 'reminder',
    path: `${process.env.REACT_APP_PREFIX}/reminder`,
    menu: process.env.REACT_APP_PREFIX,
    dashboardType: '1'
  },
  settings: {
    component: 'SettingsPage',
    name: 'settings',
    path: `${process.env.REACT_APP_PREFIX}/settings`,
    menu: `${process.env.REACT_APP_PREFIX}/account`,
    dashboardType: '1'
  },
  SelectInstitutionPage: {
    component: 'SelectInstitutionPage',
    name: 'select-institution',
    path: `${process.env.REACT_APP_PREFIX}/select-institution`,
    menu: process.env.REACT_APP_PREFIX,
    dashboardType: '3'
  }
}

export const registerSidebar = [
  {
    key: 1,
    name: 'Profil Institusi'
  },
  {
    key: 2,
    name: 'Kontak & Domisili Institusi'
  },
  {
    key: 3,
    name: 'NPWP'
  },
  {
    key: 4,
    name: 'Nomor Induk Berusaha (NIB)'
  },
  {
    key: 5,
    name: 'Akta Pendirian Institusi'
  },
  {
    key: 6,
    name: 'Akta Perubahan Terakhir'
  },
  {
    key: 7,
    name: 'Rekening Bank'
  },
  {
    key: 8,
    name: 'Pemegang Saham'
  },
  {
    key: 9,
    name: 'Susunan Direksi'
  },
  {
    key: 10,
    name: 'Pejabat Berwenang'
  },
  {
    key: 11,
    name: 'Ketentuan Tanda Tangan'
  }
]
